<template>
  <div class="malomo-banner">
    <div ref="widget" />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { appendScript } from '@/utils/dom'

const widget = ref()

onMounted(async () => {
  await appendScript('https://js.gomalomo.com/v2/', { id: 'malomo' })
  if (!widget.value) {
    return
  }
  const malomo = window.Malomo(import.meta.env.VITE_MALOMO_KEY)
  const elements = malomo.elements()
  elements
    .create('orderLookup', {
      callback: (resp) => {
        const url = new URL('/pages/tracking', document.URL)
        url.searchParams.append('_m_id', resp.body['id'])
        window.location.href = url.toString()
      }
    })
    .mount(widget.value)
})
</script>

<style>
.malomo-order-lookup-form,
.malomo-order-lookup-section-1 {
  @apply flex flex-col gap-4;
}

.malomo-banner-align--center {
  justify-content: center;
  text-align: center;
}

.malomo-banner-align--left {
  justify-content: flex-start;
  text-align: left;
}

.malomo-banner-align--right {
  justify-content: flex-end;
  text-align: right;
}

.malomo-banner-col {
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
}

.malomo-banner-col-img {
  max-height: px;
}

.malomo-banner-header {
  font-family: -apple-system;
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  margin: 0;
  padding-bottom: 20px;
  padding-top: 20px;
  width: 100%;
}

.malomo-banner-header-row {
  background-color: transparent;
}

.malomo-banner-img {
  display: block;
  max-height: px;
}

.malomo-banner-mobile-img {
  display: none;
}

.malomo-banner .malomo-order-lookup,
.malomo-banner .malomo-shipment-tracker {
  @apply sm:max-w-md sm:rounded-2xl bg-white p-8 shadow-lg mx-auto;
}

.malomo-banner-row {
  display: flex;
}

.malomo-banner-spacer {
  display: block;
  width: 50%;
}

@media only screen and (max-width: 480px) {
  .malomo-banner-mobile-img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .malomo-banner {
    background-image: none;
    padding: 0;
  }

  .malomo-banner-col {
    flex-basis: auto;
    width: 100%;
  }

  .malomo-banner-col-img,
  .malomo-banner-img,
  .malomo-banner-spacer {
    display: none;
  }
}

.malomo-order-lookup-section-separator {
  font-size: 14px;
  text-align: center;
}

.powered-by-malomo {
  font-size: 10px;
  text-align: center;
}





  .malomo-banner .malomo-shipment-tracker-carrier-info {
    /* align-items: start; */
    line-height: 1;
    padding-top: 15px;
    display: flex;
    flex-direction: column;
  }

  .malomo-banner .malomo-shipment-tracker-carrier-info-name {
    font-size: smaller;
    line-height: 1;
    text-transform: uppercase;
    margin-bottom: 4px;
  }

  .malomo-banner .malomo-shipment-tracker-countdown {
    font-size: larger;
    line-height: 1;
    margin-bottom: 10px;
    text-align: left;
  }

  .malomo-banner .malomo-shipment-tracker-delivered-message {
    line-height: 1;
    text-align: left;
  }

  .malomo-banner .malomo-shipment-tracker-delivered-message-container {
    background-color: #EEEEEE;
    border-radius: 0.5rem;
    line-height: 1;
    margin: 8px 0;
    padding: 16px;
  }

  .malomo-banner .malomo-shipment-tracker-delivered-message-header {
    align-items: normal;
  }

  .malomo-banner .malomo-shipment-tracker-delivered-message-open {
    color: inherit;
  }

  .malomo-banner .malomo-shipment-tracker-delivered-message-text {
    line-height: 1.5;
    margin: 0;
  }

  .malomo-banner .malomo-shipment-tracker-delivered-message-title {
    font-weight: bold;
    line-height: 1;
    margin-bottom: 5px;
  }

  .malomo-banner .malomo-shipment-tracker-delivery-state {
    font-size: smaller;
    line-height: 1;
    margin-bottom: 5px;
    text-align: left;
    text-transform: uppercase;
  }

  .malomo-banner .malomo-shipment-tracker-event {
    line-height: 1;
    text-align: left;
  }

  .malomo-banner .malomo-shipment-tracker-event-location-city + .malomo-shipment-tracker-event-location-state::before {
    content: ', ';
  }

  .malomo-banner .malomo-shipment-tracker-event-location-city {
    text-transform: capitalize;
  }

  .malomo-banner .malomo-shipment-tracker-event-location-state {
    text-transform: uppercase;
  }

  .malomo-banner .malomo-shipment-tracker-event-timestamp {
    margin-bottom: 2px;
  }

  .malomo-banner .malomo-shipment-tracker-event-timestamp-date {
    font-weight: bold;
    line-height: 1;
    margin-right: 6px;
  }

  .malomo-banner .malomo-shipment-tracker-events-backdrop {
    z-index: 999;
  }

  .malomo-banner .malomo-shipment-tracker-events-header-label {
    font-size: 20px;
  }

  .malomo-banner .malomo-shipment-tracker-event {
    padding: 12px 0;
  }

  .malomo-banner .malomo-shipment-tracker-events {
    height: 400px;
    overflow: scroll;
  }

  .malomo-banner .malomo-shipment-tracker-events > .malomo-shipment-tracker-event:first-child {
    padding: 0 0 12px;
  }

  .malomo-banner .malomo-shipment-tracker-events-modal {
    @apply max-w-md rounded-2xl p-4;
    width: 100%;
  }

  .malomo-banner .malomo-shipment-tracker-events-header {
    padding: 24px 0 12px 0;
  }

  .malomo-banner .malomo-shipment-tracker-events-header-close-icon {
    height: 15px;
    width: 15px;
  }

  .malomo-banner .malomo-shipment-tracker-header {
    margin-bottom: 20px;
  }

  .malomo-banner .malomo-shipment-tracker-history {
    margin-bottom: 5px;
  }

  .malomo-banner .malomo-shipment-tracker-history-control {
    align-items: center;
    background-color: #DEE4E7;
    border-color: ;
    border-radius: 3px;
    border-style: solid;
    border-width: 0px;
    color: #222222;
    display: flex;
    font-size: medium;
    height: 48px;
    justify-content: center;
    margin-top: 15px;
    cursor: pointer;
    text-transform: capitalize;
    width: 100%;
  }

  .malomo-banner .malomo-shipment-tracker-latest-activity {
    font-size: smaller;
    line-height: 1;
    margin-bottom: 4px;
    text-align: left;
    text-transform: uppercase;
  }

  .malomo-banner .malomo-shipment-tracker-most-recent-event {
    margin-bottom: 12px;
  }

  .malomo-banner .malomo-shipment-tracker-most-recent-event > .malomo-shipment-tracker-event {
    padding: 0;
  }

  .malomo-banner .malomo-shipment-tracker-return-actions {
    margin-bottom: 4px;
    margin-top: 20px;
  }

  .malomo-banner .malomo-shipment-tracker-return-actions-initiate-return-link,
  .malomo-banner .malomo-shipment-tracker-return-actions-original-order-link,
  .malomo-banner .malomo-shipment-tracker-return-actions-related-return-link {
    color: inherit;
    text-decoration: underline;
  }

  .malomo-banner .malomo-shipment-tracker-return-actions-initiate-return-prompt {
    font-size: smaller;
    line-height: 1;
    margin-bottom: 10px;
    text-align: left;
    text-transform: uppercase;
  }

  .malomo-banner .malomo-shipment-tracker-return-actions-related-returns {
    margin-top: 30px;
  }

  .malomo-banner .malomo-shipment-tracker-return-actions-related-returns-title {
    font-size: smaller;
    line-height: 1;
    margin-bottom: 10px;
    text-align: left;
    text-transform: uppercase;
  }

  .malomo-banner .malomo-shipment-tracker-selector-item.malomo-shipment-tracker-selector-active {
    background-color: #DEE4E7;
  }

  .malomo-banner .malomo-shipment-tracker-selector-item {
    border-color: #DEE4E7;
  }

  .malomo-banner .malomo-shipment-tracker-selector-counter {
    font-size: small;
    margin-bottom: 20px;
    text-align: left;
  }

  .malomo-banner .malomo-shipment-tracker-delivery-date,
  .malomo-banner .malomo-shipment-tracker-status-message {
    font-size: xx-large;
    line-height: 1;
    text-align: left;
    text-transform: capitalize;
  }

  .powered-by-malomo {
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 2rem auto 0 auto;
  }

  .powered-by-malomo a {
    color: #ffffff;
    font-size: 10px;
    mix-blend-mode: exclusion;
    opacity: 0.5;
  }

  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
    .malomo-banner .malomo-shipment-tracker {
      max-width: 100%;
    }

    .malomo-banner .malomo-shipment-tracker-events-modal {
      border-radius: 0;
      height: 100%;
    }
  }

  .malomo-order-lookup-error-message {
    @apply p-4 bg-red-50 rounded-2xl mb-4;
  }

</style>
